import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { StateService } from "../../services/state.service";

@Component({
  selector: "app-expandable-table",
  templateUrl: "./expandable-table.component.html",
  styleUrl: "./expandable-table.component.scss",
})
export class ExpandableTableComponent implements OnChanges {
  @Input() tableColumns: any[] = [];
  @Input() tableData: any[] = [];
  expandedRows: any = {};
  @Input() dataFrom!: "eda" | "executive-summary";
  @Input() withFinancialImpact: any;

  constructor(private stateService: StateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tableData?.currentValue) {
      this.tableData = changes?.tableData?.currentValue;
    }
    if (changes.tableColumns?.currentValue) {
      this.tableColumns = changes?.tableColumns?.currentValue;
      if (this.dataFrom === "executive-summary") {
        this.addColumnCustomizations(this.tableColumns);
      }
    }
  }

  getColumnWidth(index: number): string {
    if (index === 0) {
      return "0px";
    } else if (index === 1) {
      return "80px";
    } else {
      return "60px";
    }
  }

  toFixedToZeroDigits(val: any) {
    if (typeof val === "string") {
      return val !== "" ? val : "-";
    } else if (!isNaN(val) && val !== null && val !== undefined) {
      return Number.isInteger(val)
        ? this.formatNumber(Number(val.toFixed(0)))
        : this.formatNumber(Number(val.toFixed(1)));
    } else {
      return val || "-";
    }
  }

  formatNumber(num: number): string {
    if (typeof num !== "number" || !isFinite(num)) return "";
    const [integerPart, decimalPart] = Math.abs(num).toString().split(".");
    const safeInteger = integerPart.replace(/\d(?=(\d{3})+$)/g, "$&,");
    return (
      (num < 0 ? "-" : "") +
      safeInteger +
      (decimalPart ? "." + decimalPart : "")
    );
  }

  addColumnCustomizations(columns: any[]): void {
    const labelToColorMap: { [key: string]: string } = {
      Keep: "#DFF2E0",
      Consult: "#FAF2D5",
      Delist: "#F6DDDE",
      Grow: "#FAF2D5",
      Dtp: "#DBDBDB",
      Accelerate: "#FAF2D5",
      Optimize: "#DBDBDB",
      Total: "var(--pho_white_shade1a)",
      "Unhealthy Portfolio Pre Delist (%)": "var(--pho_white_shade1a)",
      "% Cannibalization (%)": "var(--pho_primary_100)",
      "Volume Retained": "var(--pho_primary_100)",
      "MACO Uplift": "var(--pho_primary_100)",
    };

    columns.forEach((column: any) => {
      const bgColor = labelToColorMap[column.label];
      if (bgColor) {
        column["headerBgColor"] = bgColor;
      }
    });
  }
}
